import React from "react";

export const CabinetEmailAppConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: "/cabinet/mission-offer-response/:offreMissionId?/token/:token?/:typeAction/:typeMenu?",
      component: React.lazy(() =>
        import("./components/FolderEmail/DisplayMail")
      ),
    },
    {
      path: "/cabinet/mission-offer-response/:offreMissionId?/:typeAction/:typeMenu?",
      component: React.lazy(() =>
        import("./components/FolderEmail/DisplayMail")
      ),
    },
  ],
};
